export function getView(value) {
  return value?.aggregate?.count > 0 ? 'Active' : 'InActive'
}
